import { render, staticRenderFns } from "./ModalResponder.vue?vue&type=template&id=7bf23456&scoped=true&"
import script from "./ModalResponder.vue?vue&type=script&lang=js&"
export * from "./ModalResponder.vue?vue&type=script&lang=js&"
import style0 from "./ModalResponder.vue?vue&type=style&index=0&id=7bf23456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf23456",
  null
  
)

export default component.exports